import { postForm } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface PostInstallationParams {
  projectId: string;
  installationName: string;
  installationPlan: File;
}

export function usePostInstallation() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ projectId, formData }: { projectId: string; formData: FormData }) =>
      postForm({
        url: `/projects/${projectId}/installations`,
        body: formData,
      }),
    onSuccess: (_, { projectId }) =>
      queryClient.invalidateQueries({
        queryKey: queryKeys.getInstallations(projectId),
      }),
  });

  const postInstallation = useCallback(
    ({ projectId, installationName, installationPlan }: PostInstallationParams) => {
      const formData = new FormData();
      formData.append('installationData', JSON.stringify({ installationName }));
      formData.append('installationMap', installationPlan);

      mutate({ projectId, formData });
    },
    [mutate]
  );

  return {
    postInstallation,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
